import { setAccessToken, setUser, setUserAfterSave, setChildren, setActiveUserId } from "./userSlice.js"
import md5 from 'md5-hash';
import { fetchBookUserData, fetchBlackList } from "../Statistics/statisctics.js"
import { SaveLogin, DeleteLogin } from "../database/login.js"
import { setLevelId } from "../search/searchSlice.js";

function getErrorMessage(data, fallback) {
  if (typeof data?.message === "string" && data.message.trim().length > 0) {
    return data.message;
  }
  if (typeof data?.error_description === "string" && data.error_description.trim().length > 0) {
    return data.error_description;
  }
  if (typeof data?.error === "string" && data.error.trim().length > 0) {
    return data.error;
  }
  return fallback;
}

async function parseJsonResponse(response) {
  try {
    return await response.json();
  } catch (_) {
    return null;
  }
}

function ensureAuthPayload(data) {
  const accessToken = data?.access_token;
  const refreshToken = data?.refresh_token ?? null;
  const resolvedUser = data?.user ?? data?.result ?? null;
  const resolvedUserId = resolvedUser?.id;

  if (!accessToken || !resolvedUser || resolvedUserId === null || resolvedUserId === undefined) {
    throw new Error(getErrorMessage(data, "Invalid authentication response"));
  }

  return {
    accessToken,
    refreshToken,
    resolvedUser,
    resolvedUserId,
  };
}

export function loginWithToken({ token, ssoId, returnUrl }) {
    //call endpoint
    var url = process.env.REACT_APP_APIBASE +"oauth/sso/app/login/" + ssoId + "?token=" + token + "&returnUrl=" + returnUrl;
    //var url = process.env.REACT_APP_APIBASE +"oauth/sso/app/login/" + ssoId + "?token=" + token + "&platform=web";
    window.location.replace(url);
  }

export function loginWithCode({ code, ssoId, returnUrl }) {
    var url = process.env.REACT_APP_APIBASE +"oauth/sso/app/login/" + ssoId + "?code=" + code + "&returnUrl=" + returnUrl;
    window.location.replace(url);
  }

export function loginWithAccessToken(dispatch, accessToken) {
    dispatch(setAccessToken(accessToken));

    var myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", "Bearer " + accessToken);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(process.env.REACT_APP_APIBASE + "mobile/users/me", requestOptions)
      .then(async response => {
        const data = await parseJsonResponse(response);
        if (!response.ok) {
          throw new Error(getErrorMessage(data, "Could not load user profile"));
        }
        return data;
      })
      .then(async data => {
        await parseUserDataResult(dispatch, data, accessToken, null);
      })
      .catch(error => console.log('error', error));

  }

export async function loginWithServerToken(dispatch, { token, ssoId }, onReturned) {
    var myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      "token": token,
      "sso_id": ssoId,
      "client_id": "2",
      "client_secret": "BookrAWOauthClientDummySecret4Mobile0000"
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    try {
      const response = await fetch(process.env.REACT_APP_APIBASE + "oauth/token/sso", requestOptions);
      const data = await parseJsonResponse(response);
      if (!response.ok) {
        throw new Error(getErrorMessage(data, "SSO authentication failed"));
      }
      await parseUserData(dispatch, data, null, null);
      if (onReturned) {
        onReturned(true, "Logged In");
      }
    } catch (error) {
      console.log('sso login error', error);
      if (onReturned) {
        onReturned(false, error?.message ?? "SSO authentication failed");
      }
    }
    }

function convertPassword(string) {
  return md5(string);
  //return await hash(string);
}

//// --------- PARSE FOUND DATA

async function parseUserData(dispatch, data, onReturned, activeUserId) {
  try {
    const authPayload = ensureAuthPayload(data);
    const resolvedActiveUserId = activeUserId ?? authPayload.resolvedUserId;
    await SaveLogin({
      access_token: authPayload.accessToken, 
      refresh_token: authPayload.refreshToken, 
      user: authPayload.resolvedUser,
      activeUserId: resolvedActiveUserId
    })
    dispatch(setAccessToken(authPayload.accessToken));
    dispatch(setUser(authPayload.resolvedUser));
    if (resolvedActiveUserId !== null && resolvedActiveUserId !== undefined)
      dispatch(setActiveUserId(resolvedActiveUserId));
  
    if (authPayload.resolvedUser?.type === "child" && authPayload.resolvedUserId)
    {
      await fetchBookUserData(dispatch, authPayload.accessToken, authPayload.resolvedUserId);
      await fetchBlackList(dispatch, authPayload.accessToken, authPayload.resolvedUserId);
      if (onReturned)
        onReturned(true, "Logged In");
    }
    else if (onReturned)
      onReturned(true, "Logged In");  
  } catch (excpetion)
  {
    if (onReturned)
      onReturned(false, excpetion);
    else
      throw excpetion;
  }
}


async function parseUserDataResult(dispatch, data, access_token, onReturned) {
  try {
    const normalizedAccessToken = (access_token && access_token !== "undefined" && access_token !== "null") ? access_token : null;
    const resolvedUser = data?.result ?? data?.user ?? (data?.id ? data : null);
    const resolvedUserId = resolvedUser?.id ?? null;
    if (!normalizedAccessToken || !resolvedUser || resolvedUserId === null || resolvedUserId === undefined) {
      throw new Error(getErrorMessage(data, "Invalid user profile response"));
    }
    await SaveLogin({
      access_token: normalizedAccessToken, 
      refresh_token: null, 
      user: resolvedUser,
      activeUserId: resolvedUserId
    })
    dispatch(setAccessToken(normalizedAccessToken));
    dispatch(setUser(resolvedUser));
    if (resolvedUserId !== null && resolvedUserId !== undefined)
      dispatch(setActiveUserId(resolvedUserId));
  
    if (resolvedUser?.type === "child" && resolvedUserId)
    {
      await fetchBookUserData(dispatch, normalizedAccessToken, resolvedUserId);
      await fetchBlackList(dispatch, normalizedAccessToken, resolvedUserId);
    }
    if (onReturned)
      onReturned(true, "Logged In");
  } catch (excpetion)
  {
    if (onReturned)
      onReturned(false, excpetion);
    else
      throw excpetion;
  }
}

/// -------- PARSE FOUND DATA END

export async function logOut(dispatch) {
  localStorage.removeItem('hasUser');
  await DeleteLogin();
  dispatch(setAccessToken(null));
  dispatch(setUser(null));
  dispatch(setChildren([]));
  dispatch(setLevelId(0));
}

async function parseUserDataAfterSave(dispatch, response, onReturned) {
  try { 
    if (!response.ok)
      throw await response.json();
    const data = await response.json();
  
   
    dispatch(setUserAfterSave(data.result));
  
    if (onReturned)
      onReturned(true, data.result.subscription);
  } catch (excpetion)
  {
    if (onReturned)
      onReturned(false, excpetion);
  }
 
}

async function parseChildrenDataAfterSave(dispatch, accessToken, response) {
  if (!response.ok)
    throw await response.json();
  const data = await response.json();

  for (var child of data.result.list)
  {
    await fetchBookUserData(dispatch, accessToken, child.id);
    await fetchBlackList(dispatch, accessToken, child.id);
  }
   
  dispatch(setChildren(data.result.list));
}

async function fetchChildren(dispatch, accessToken, onReturned) {
  try {
  var myHeaders = new Headers();
  myHeaders.append("Accept", "application/json");
  myHeaders.append("Authorization", "Bearer " + accessToken);
  
  var requestOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
  };
  
  const response = await fetch(process.env.REACT_APP_APIBASE + "mobile/children", requestOptions);
  
  await parseChildrenDataAfterSave(dispatch, accessToken, response);
  } catch(error) {
      console.log('error', error);
      if (onReturned)
        onReturned(false, error.message);
  };
}

export async function refreshMe(dispatch, accessToken, onReturned) {
  try {
  var myHeaders = new Headers();
  myHeaders.append("Accept", "application/json");
  myHeaders.append("Authorization", "Bearer " + accessToken);
  
  var requestOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
  };
  
  const response = await fetch(process.env.REACT_APP_APIBASE + "mobile/users/me", requestOptions);
  await fetchChildren(dispatch, accessToken);
  await parseUserDataAfterSave(dispatch, response, onReturned);
  } catch(error) {
      console.log('error', error);
      if (onReturned)
        onReturned(false, error.message);
  };
}

export async function saveChild(dispatch, userData, accessToken, onReturned) {
  try {
  var myHeaders = new Headers();
  myHeaders.append("Accept", "application/json");
  myHeaders.append("Authorization", "Bearer " + accessToken);
  myHeaders.append("Content-Type", "application/json");
  
  var raw = JSON.stringify(userData);
  
  var requestOptions = {
    method: 'PUT',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };
  
  const response = await fetch(process.env.REACT_APP_APIBASE + "mobile/child/" + userData.id, requestOptions);
  await parseUserDataAfterSave(dispatch, response, onReturned);
  } catch(error) {
      console.log('error', error);
      if (onReturned)
        onReturned(false, error.message);
  };
}

export async function saveMe(dispatch, userData, accessToken, onReturned) {
  try {
  var myHeaders = new Headers();
  myHeaders.append("Accept", "application/json");
  myHeaders.append("Authorization", "Bearer " + accessToken);
  myHeaders.append("Content-Type", "application/json");
  
  var raw = JSON.stringify(userData);
  
  var requestOptions = {
    method: 'PUT',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };
  
  const response = await fetch(process.env.REACT_APP_APIBASE + "mobile/users/me", requestOptions);
  await parseUserDataAfterSave(dispatch, response, onReturned);
  } catch(error) {
      console.log('error', error);
      if (onReturned)
        onReturned(false, error.message);
  };
}

export async function refreshToken(dispatch, refresh_token, onReturned, activeUserId) {
  try {
    console.log(activeUserId);
  var myHeaders = new Headers();
  myHeaders.append("Accept", "application/json");
  myHeaders.append("Content-Type", "application/json");
  
  var raw = JSON.stringify({
    "refresh_token": refresh_token,
    "client_id": "2",
    "client_secret": "BookrAWOauthClientDummySecret4Mobile0000"
  });
  
  var requestOptions = {
    method: 'PUT',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };
  
  const response = await fetch(process.env.REACT_APP_APIBASE + "oauth/token", requestOptions);
  if (!response.ok)
    throw await response.json();

  console.log("refresh token success");
  const data = await response.json();
  await fetchChildren(dispatch, data.access_token);
  await parseUserData(dispatch, data, onReturned, activeUserId);

  } catch(error) {
      console.log('refresh token error');
      console.log('error', error);
      logOut(dispatch);
      if (onReturned)
        onReturned(false, error.message);
  };
}

export async function loginWithAccessCode(dispatch, accessCode, onReturned) {
  try {
  var myHeaders = new Headers();
  myHeaders.append("Accept", "application/json");
  myHeaders.append("Content-Type", "application/json");
  
  var raw = JSON.stringify({
    "accessCode": accessCode,
    "client_id": "2",
    "client_secret": "BookrAWOauthClientDummySecret4Mobile0000"
  });
  
  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };
  
  const response = await fetch(process.env.REACT_APP_APIBASE + "oauth/token/accessCode", requestOptions);
  if (!response.ok)
    throw await response.json();
  const data = await response.json();
  await fetchChildren(dispatch, data.access_token);
  await parseUserData(dispatch, data, onReturned);  
  } catch(error) {
      console.log('error', error);
      if (onReturned)
        onReturned(false, error.message);
  };
}

export async function registerUser(dispatch, { name, userName, password, school, userType, newsLetter }, onReturned) {
  try {
    
  const converted = convertPassword(password);
  var myHeaders = new Headers();
  myHeaders.append("Accept", "application/json");
  myHeaders.append("Content-Type", "application/json");

  var raw = null;
  
  if (userType.toLowerCase() !== "teacher") {
    raw = JSON.stringify({
      username: userName,
      password: converted,
      name: name,
      "client_id": "2",
      "client_secret": "BookrAWOauthClientDummySecret4Mobile0000",
      consentMarketing : true,
      consentChildStats: true,
      consentNewsletter: newsLetter,
      type: userType
    });
  } else {
    raw = JSON.stringify({
      username: userName,
      password: converted,
      name: name,
      schoolName: school,
      "client_id": "2",
      "client_secret": "BookrAWOauthClientDummySecret4Mobile0000",
      consentMarketing : true,
      consentChildStats: true,
      consentNewsletter: newsLetter,
      type: userType
    });
  }

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };
  
  const response = await fetch(process.env.REACT_APP_APIBASE + "mobile/users/me", requestOptions);
  if (!response.ok)
    throw await response.json();

  await loginWithUsernameAndPassword(dispatch, { userName, password }, onReturned);
  } catch(error) {
      console.log('error', error);
      if (onReturned)
        onReturned(false, error.message);
  };
}

export async function loginWithUsernameAndPassword(dispatch, { userName, password }, onReturned) {
  try {
    
  const converted = convertPassword(password);
  var myHeaders = new Headers();
  myHeaders.append("Accept", "application/json");
  myHeaders.append("Content-Type", "application/json");
  
  var raw = JSON.stringify({
    "username": userName,
    "password": converted,
    "client_id": "2",
    "client_secret": "BookrAWOauthClientDummySecret4Mobile0000"
  });
  
  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };
  
  const response = await fetch(process.env.REACT_APP_APIBASE + "oauth/token/password", requestOptions);
  if (!response.ok)
    throw await response.json();
  const data = await response.json();
  await fetchChildren(dispatch, data.access_token);
  await parseUserData(dispatch, data, onReturned);
  } catch(error) {
      console.log('error', error);
      if (onReturned)
        onReturned(false, error.message);
  };
}
  
